import React from "react";
import Box from "@mui/material/Box";
import { HeaderLP } from "@layouts/Main/lib/Header/HeaderLP";
import Footer from "@layouts/Footer";
import type { TFooterProps } from "@layouts/Footer/type";
// import BottomNav from "@fragments/BottomNavigation";
import Navigation from "@pwa/layout/Navigation";

const LandingPageLayout: React.FC<{
  children: React.ReactNode;
  footer?: TFooterProps;
  hideBottomNav?: boolean;
}> = ({ children, footer, hideBottomNav = false }) => {
  return (
    <Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <HeaderLP />
      </Box>

      <Box>{children}</Box>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Footer {...footer} />
      </Box>

      {!hideBottomNav && (
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          {/* <BottomNav /> */}
          <Navigation />
        </Box>
      )}
    </Box>
  );
};

export default LandingPageLayout;
